// ** React Imports
import { useState, useEffect, SyntheticEvent, useRef } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
} from '@mui/material'
import { useParams } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import appInfo from '../../../../configs/app-info';
import { useToast } from '../../../../components/ToastProvider';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();
    
    const [valGudang, setValGudang] = useState<any>(null)
    const [valGudangTujuan, setValGudangTujuan] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])
    const [listSubGudangAsal, setListSubGudangAsal] = useState<any[]>([])
    const [listSubGudangTujuan, setListSubGudangTujuan] = useState<any[]>([])
    const [listBarang, setListBarang] = useState<any[]>([])
    const [valBarang, setValBarang] = useState<any>(null)
    const [isBatch, setIsBatch] = useState<any>(false)
    const [isEdit, setIsEdit] = useState<any>(false)
    const [batch, setBatch] = useState<any>('')

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [listDetail, setListDetail] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const { showToast, hideToast } = useToast();
    const inputRef = useRef<HTMLInputElement>(null)


    useEffect(() => {
        getData()
        getDetail()
        getBarang()
        setValue('mmtransfer_id', id)
    }, [])

    const getDoctag = (ids: any) => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
        .get(url, {
            params: {sysmenu_id: appInfo.menuId.transferStok},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                data.forEach((element: any) => {
                if (element.id === ids) {
                    setValDoctag(element)
                    setValue('sysdoctag_id', element.id)
                }
            });
                setListDoctag(data)
            } else {
                showToast(response.data.message, 'error' )
            }
        })
    }
    const getBarang = () => {
        const url = apiUrl.apiUrl + '/mm/transfer-stok/list-combo-item'
        axios
        .get(url, {
            params: {sysmenu_id: appInfo.menuId.transferStok},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                setListBarang(data)
            } else {
                showToast(response.data.message, 'error' )
            }
        })
    }

    const getGudang = (ids: any,isTujuan: boolean) => {
        const url = apiUrl.apiUrl + '/mm/gudang/list-combo'
        axios
        .get(url, {
            params: {},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                data.forEach((element: any) => {
                    if (element.id === ids) {
                        if(isTujuan){
                            setValGudangTujuan(element)
                            setValue('mmgudang_tujuan_id', element.id)
                        } else {
                            setValGudang(element)
                            setValue('mmgudang_asal_id', element.id)
                        }
                    }
                });
                setListGudang(data)
            } else {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: response.data.message,
                    icon: 'error'
                })
            }
        })
    }
    
    const getSubGudangAsal = (gudangId: any) => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
        .get(url, {
            params: {mmgudang_id: gudangId},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                setListSubGudangAsal(data)
            } else {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: response.data.message,
                    icon: 'error'
                })
            }
        })
    }
    const getSubGudangTujuan = (gudangId: any) => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
        .get(url, {
            params: {mmgudang_id: gudangId},
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {
            if (response.data.success) {
                const data = response.data.data
                setListSubGudangTujuan(data)
            } else {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: response.data.message,
                    icon: 'error'
                })
            }
        })
    }
    const getDetail = () => {
        const url = apiUrl.apiUrl + '/mm/transfer-stok/detail-item/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListDetail(response.data.data)
                } else {
                    showToast(response.data.message, 'error' )
                }
            })
            .catch(error => {
                showToast(error.message, 'error' )
            })
    }

    const ActionButtons = ({ row, onDelete }: { 
        row: any; 
        onDelete: (row: any) => void; 
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => {
                    axios
                        .get(`${apiUrl.apiUrl}/mm/transfer-stok/item-detail/${row.id}`, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                const data = response.data.data;
                                setOpenDialog(true);
                                resetDetail();
                                setIsEdit(true);
                                if(data.mmbarang_batch_batch_idid != null){
                                    setIsBatch(true);
                                    setBatch(data.mmbarang_batch_id);
                                    setValue('mmbarang_batch_id', data.mmbarang_batch_id);
                                } else {
                                    setIsBatch(false);
                                    setBatch('');
                                    setValue('mmbarang_batch_id', '');
                                }
                                setValue('mmtransfer_d_id', data.id);
                                setValBarang(response.data.barang);
                                setValue('mmbarang_id', data.mmbarang_id);
                                setValue('qty', data.qty);
                                setValue('mmgudang_sub_asal_id', data.mmgudang_sub_asal_id);
                                setValue('mmgudang_sub_tujuan_id', data.mmgudang_sub_tujuan_id);
                                setValue('keterangan_detail', data.keterangan);
                                
                            } else {
                                showToast(response.data.message, 'error');
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                }
            },
            {
                title: "Hapus Transfer Stok", 
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };
    
    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons 
                    row={row} 
                    onDelete={() => {
                        axios
                            .delete(`${apiUrl.apiUrl}/mm/transfer-stok/delete-item/${row.id}`, {
                                headers: { Authorization: `Bearer ${token}` }
                            })
                            .then(response => {
                                Swal.close()
                                if (response.data.success) {
                                    showToast(response.data.message, 'success')
                                    getDetail()
                                } else {
                                    showToast(response.data.message, 'error')
                                }
                            })
                            .catch(error => {
                                showToast(error.message, 'error')
                            })
                    }}
                />
            ),
        },
    ];
    
    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_asal_id', newValue ? newValue.id : null)
        setValGudang(newValue )
    }
    const handleChangeAutocompleteGudangTujuan = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_tujuan_id', newValue ? newValue.id : null)
        setValGudangTujuan(newValue)
    }

    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/transfer-stok/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setValue('syscabang_id', data.syscabang_id)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('mmgudang_asal_id', data.mmgudang_asal_id)
                    setValue('mmgudang_tujuan_id', data.mmgudang_tujuan_id)
                    setValue('tgl', data.tgl)
                    setValue('keterangan', data.keterangan)
                    setValue('pic', data.pic)
                    getDoctag(data.sysdoctag_id)
                    getGudang(data.mmgudang_asal_id, false)
                    getGudang(data.mmgudang_tujuan_id, true)
                    getSubGudangAsal(data.mmgudang_asal_id)
                    getSubGudangTujuan(data.mmgudang_tujuan_id)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }
    interface FormInputs {
        mmtransfer_id: any,
        syscabang_id: any,
        sysdoctag_id: any,
        mmgudang_asal_id: any,
        mmgudang_tujuan_id: any,
        tgl: any,
        keterangan: any,
        pic: any,
        mmgudang_sub_asal_id: any,
        mmgudang_sub_tujuan_id: any,
        mmbarang_id: any,
        qty: any,
        keterangan_detail: any,
        mmbarang_batch_id: any,
        mmtransfer_d_id: any,

    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const resetDetail = () => {
        setValue('mmgudang_sub_asal_id', '')
        setValue('mmgudang_sub_tujuan_id', '')
        setValue('mmbarang_id', '')
        setValue('qty', '')
        setValue('keterangan_detail', '')
        setValBarang(null)
        setValue('mmtransfer_d_id', '')
    }

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            const batchId = getValues('mmbarang_batch_id');
            if (batchId && batchId.trim() !== '') {
                const url = apiUrl.apiUrl + '/mm/transfer-stok/check-batch/' + batchId
                axios
                    .get(url, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success && response.data.data) {
                            setIsBatch(response.data.data.is_batch);
                            setOpenDialog(true);
                            setIsEdit(false);
                            resetDetail();
                            setValBarang(response.data.data);
                            setValue('mmbarang_id', response.data.data.id);
                            setBatch(response.data.data.is_batch ? batchId : '');
                            setValue('mmbarang_batch_id', '');
                        } else {
                            setValue('mmbarang_batch_id', '');
                            showToast('Batch ID tidak ditemukan', 'error');
                        }
                    })
                    .catch(error => {
                        setValue('mmbarang_batch_id', '');
                        showToast(error.message, 'error');
                    });
            }
        }
    }

    const onSubmit = (data: any) => {
        const url = apiUrl.apiUrl + '/mm/transfer-stok/edit/' + id
        axios
            .post(url, data, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success' )
                } else {
                    showToast(response.data.message, 'error' )
                }
            })
            .catch(error => {
                showToast(error.message, 'error' )
            })
    }
    const handleChangeAutocompleteBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_id', newValue?.id)
        setValBarang(newValue ? newValue : null)
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Transfer Stok
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <br />
                    <Divider sx={{ mt: 0, mb: 3 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        disabled
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                          getOptionLabel={(option: any) => option.nama || ''}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudang}
                                        options={listGudang}
                                        id='gudang_asal'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteGudang}
                                        getOptionLabel={(option: any) => option.nama || ''}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Gudang Asal'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudangTujuan}
                                        options={listGudang}
                                        id='gudang_tujuan'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteGudangTujuan}
                                        getOptionLabel={(option: any) => option.nama || ''}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Gudang Tujuan'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.pic)}
                                            />
                                        )}
                                    />
                                    {errors.pic && (
                                        <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                InputLabelProps={{ shrink: true }}
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4, mb: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                    <Divider sx={{ m: 0 }} />
                    <Box sx={{ mt: 4 }}>
                        <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_batch_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputRef={inputRef}
                                                value={value || ''}
                                                label='Scan Barang / Batch'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                onKeyDown={handleKeyDown}
                                            />
                                        )}
                                    />
                                    {errors.mmbarang_batch_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}></Grid>
                            <Grid item xs={12} sm={2}>
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    fullWidth
                                    onClick={() => {
                                        setIsEdit(false);
                                        setIsBatch(false);
                                        setOpenDialog(true);
                                        resetDetail();
                                    }}
                                >
                                    Transfer Stok Barang
                                </Button>
                            </Grid>
                        </Grid>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            LIST BARANG
                        </Typography>
                        <Box sx={{ overflowX: 'auto' }}>
                            <MsiDatagrid key={1} array={listDetail} actions={actionData} />
                        </Box>
                    </Box>
                </div>
            </Grid>
            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
            >
                <form onSubmit={handleSubmit((data) => {
                    setOpenDialog(false)
                    if(isBatch){
                        data.mmbarang_batch_id = batch;
                    }

                    let url = '';
                    if(isEdit){
                        url = apiUrl.apiUrl + '/mm/transfer-stok/edit-item/' + data.mmtransfer_d_id
                    } else {
                        url = apiUrl.apiUrl + '/mm/transfer-stok/add-item'
                    }
                    axios
                        .post(url, data, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message,'success');
                                getDetail(); // ✅ refresh data
                                setOpenDialog(false); // ✅ tutup setelah sukses
                                Swal.close();
                            } else {
                                showToast(response.data.message,'error');
                                Swal.close();
                            }
                        })
                        .catch(error => {
                            showToast(error.message,'error');
                            Swal.close();
                        })
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Item
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            {isBatch ? 
                            <Grid item xs={12} sm={isBatch ? 12 : 6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Batch ID
                                </Typography>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Batch ID'
                                        value={batch}
                                        InputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            : null }
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Barang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valBarang}
                                                options={listBarang}
                                                id='mmbarang_id'
                                                readOnly={isBatch ? true : false}
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteBarang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        error={Boolean(errors.mmbarang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmbarang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Qty
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Qty'
                                                error={Boolean(errors.qty)}
                                                onChange={onChange}
                                                value={value}
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Sub Gudang Asal
                                </Typography>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Gudang Asal</InputLabel>
                                    <Controller
                                        name='mmgudang_sub_asal_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Sub Gudang Asal'
                                                value={value || ''}
                                                onChange={e => {
                                                    onChange(e);
                                                    setValue('mmgudang_sub_asal_id', e.target.value);
                                                }}
                                                error={Boolean(errors.mmgudang_sub_asal_id)}
                                            >
                                                {listSubGudangAsal.map((item: any, index: any) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmgudang_sub_asal_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                    Sub Gudang Tujuan
                                </Typography>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Gudang Tujuan</InputLabel>
                                    <Controller
                                        name='mmgudang_sub_tujuan_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Sub Gudang Tujuan'
                                                value={value || ''}
                                                onChange={e => {
                                                    onChange(e);
                                                    setValue('mmgudang_sub_tujuan_id', e.target.value);
                                                }}
                                                error={Boolean(errors.mmgudang_sub_tujuan_id)}
                                            >
                                                {listSubGudangTujuan.map((item: any, index: any) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmgudang_sub_tujuan_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_detail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                InputLabelProps={{ shrink: true }}
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid >
    )
}
